import create from "zustand";

interface ParticipantJoinStore {
  maskedEmail: string | null;
  setMaskedEmail: (value: string) => void;
}

export const useParticipantJoinStore = create<ParticipantJoinStore>((set) => ({
  maskedEmail: null,
  setMaskedEmail: (value) => set({ maskedEmail: value }),
}));
